import { GlobalEnumerationsAceXfoundportalobjekt } from '@/api/model-index';
import { FocusService } from '@/core/services/focus.service';
import { FocusManagedDialogComponent } from '@/core/components/dialogs/focus-managed-dialog.component';
import { Component, inject, Input, OnDestroy, Type } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { ComponentService } from '@/core/services/component.service';
import { ChatComponent } from '@/core/components/chat/chat.component';

@Component({
  selector: 'app-chat-dialog',
  templateUrl: './chat-dialog.component.html',
  styleUrls: ['./chat-dialog.component.scss'],
  standalone: false
})
export class ChatDialogComponent extends FocusManagedDialogComponent {
  @Input()
  public anfrageId: string;
  @Input()
  public scope: GlobalEnumerationsAceXfoundportalobjekt;
  @Input()
  public anfrageTitel: string;

  protected componentService = inject(ComponentService);

  constructor(dialog: DialogRef, protected focusService: FocusService) {
    super(focusService, dialog);
  }
  
  public get chatComponent(): Type<ChatComponent> {
    return this.componentService.get(ChatComponent);
  }
}
